const serviceData = [
    {
      alt: "Stroke Recovery",
      name: "Stroke Recovery",
      imglink: require("./Images/strokerecovery.png"),
      desc: "Stroke recovery combines medical expertise, therapy, and support for regaining independence and quality of life. Personalized care and monitoring pave the way to a brighter future.",
      descmore: "Our dedicated team is committed to celebrating your milestones, no matter how small, and guiding you through the challenges of stroke recovery. Take the first step towards your brighter future by contacting us today for compassionate and effective stroke rehabilitation."
    },
    {
      alt: "Parkinson's Recovery",
      name: "Parkinson's Recovery",
      imglink: require("./Images/img2.jpg"),
      desc: "Parkinson's recovery is a journey that involves a combination of medical management, physical therapy, and lifestyle adjustments to alleviate symptoms and improve daily functioning.",
      descmore: "While there is no cure for Parkinson's disease, a comprehensive and individualized approach to treatment can help individuals with Parkinson's lead fulfilling lives with improved mobility and quality of life."
    },
    {
      alt: "Geriatric Rehabilitation",
      name: "Geriatric Rehabilitation",
      imglink: require("./Images/GeriatricRehab.jpg"),
      desc: "Geriatric rehabilitation enhances older adults' well-being by addressing mobility, balance, and cognitive issues with personalized physical therapy plans.",
      descmore: "This specialized care aims to promote independence, reduce pain, and improve the overall quality of life for seniors. Our dedicated team of healthcare professionals provides comprehensive support, helping older adults maintain their vitality and enjoy a fulfilling lifestyle."
    },
    {
      alt: "Dry Needling",
      name: "Dry Needling",
      imglink:require("./Images/Dryneedling.jpg"),
      desc: "Dry needling is a physical therapy technique that involves inserting thin needles into specific trigger points within muscles. It helps alleviate pain, reduce muscle tension, and improve range of motion by targeting areas of muscle knots and tightness.",
      descmore: "During dry needling, the needles stimulate muscle tissue, promoting blood flow and the release of endorphins, which can provide pain relief and relaxation. This therapy is often used to complement other physical therapy treatments for conditions like muscle pain, sports injuries, and chronic pain."
    },
    {
      alt: "Cupping",
      name: "Cupping",
      imglink: require("./Images/Cupping.jpg"),
      desc: "Cupping is a traditional alternative therapy that involves placing cups on the skin to create suction. This technique is believed to promote blood flow, reduce muscle tension, and provide relief from pain and inflammation.",
      descmore: "The cups used in cupping therapy can be made of various materials, including glass, silicone, or plastic. As the cups create suction, they draw the skin and underlying tissues upwards, which is thought to help release toxins, improve circulation, and promote relaxation. Cupping therapy is often used to address conditions like muscle pain, stress, and respiratory issues."
    },
    {
      alt: "Spinal Manipulation",
      name: "Spinal Manipulation",
      imglink: require("./Images/spinalmanip.png"),
      desc: "Spinal manipulation is a chiropractic technique that involves applying controlled force to spinal joints to alleviate pain, improve mobility, and promote overall spinal health.",
      descmore: "Spinal manipulation is primarily used to treat conditions such as lower back pain, neck pain, and headaches by realigning vertebral joints and reducing pressure on surrounding nerves."
    },
    {
      alt: "Sciatica",
      name: "Sciatica",
      imglink: require("./Images/Sciatica.jpg"),
      desc: "Sciatica is a painful condition caused by the compression or irritation of the sciatic nerve, often resulting in radiating pain, numbness, and tingling sensations that travel from the lower back down one leg.",
      descmore: "Sciatica can be caused by various factors, including herniated discs, spinal stenosis, or muscle spasms, and its treatment may involve pain relief measures, physical therapy, and, in some cases, surgical intervention to alleviate nerve compression."
    },
    {
      alt: "Low back pain",
      name: "Low back pain",
      imglink: require("./Images/backpain.jpg"),
      desc: "Low back pain is a prevalent condition characterized by discomfort in the lower back, often arising from factors like muscle strain, disc problems, or poor posture.",
      descmore: "Physiotherapy offers exercise-based solutions to strengthen core muscles and manual therapy techniques to alleviate low back pain and promote better spinal health."
    },
    {
      alt: "Knee pain",
      name: "Knee pain",
      imglink: require("./Images/kneepain.jpg"),
      desc: "Knee pain is discomfort in the knee joint caused by factors like injuries, arthritis, or overuse, often requiring evaluation and treatment for relief.",
      descmore: "Physiotherapy offers tailored solutions for knee pain, including exercises to strengthen muscles, joint mobilization, and pain management techniques to enhance mobility and reduce discomfort."
    },
    {
      alt: "Fracture care",
      name: "Fracture care",
      imglink: require("./Images/fracture.jpg"),
      desc: "Fracture care focuses on diagnosing, stabilizing, and treating broken bones to ensure proper healing and functional recovery.",
      descmore: "Fracture care involves the assessment, stabilization, and treatment of broken bones through methods such as casting, splinting, or surgical intervention to promote proper healing and restore function."
    },
    {
      alt: "Post surgery rehabilitation",
      name: "Post surgery rehabilitation",
      imglink: require("./Images/postsurgery.png"),
      desc: "Post-surgery rehabilitation aims to reduce pain, prevent complications, and optimize the healing process, tailored to the specific needs and goals of each patient.",
      descmore: "Post-surgery rehabilitation is a crucial aspect of recovery that involves specialized exercises, therapies, and guidance to restore mobility, strength, and function following surgical procedures."
    },
    {
      alt: "Sports Injuries",
      name: "Sports Injuries",
      imglink: require("./Images/sportsinjury.jpg"),
      desc: "Sports injuries physiotherapy is dedicated to diagnosing, treating, and rehabilitating sports-related injuries to help athletes recover and return to peak performance safely.",
      descmore: "Sports injuries physiotherapy is a specialized branch of physical therapy focused on the assessment, treatment, and rehabilitation of injuries incurred during sports activities, with the goal of restoring athletes' functionality and minimizing the risk of re-injury."
    }
  ];
  
  export default serviceData;
  